import React, { useEffect, useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import { makeStyles } from "@material-ui/core/styles";
import { List, ListItem, ListItemText } from "@material-ui/core";
import StyledCheckbox from "../../common/styledCheckbox";

const messages = defineMessages({
    filterTitle: {
        id: "common-filter.filterTitle",
        defaultMessage: "Filter",
        description: "Title for filters",
    },
    allFilterOption: {
        id: "common-filter.allFilterOption",
        defaultMessage: "All",
        description: "filtering option allowing to select all values",
    },
});
const useStyles = makeStyles({
    root: {
        textTransform: "none",
        fontFamily: "Arial",
        disableRipple: true,
        padding: "5px",
        lineHeight: 5,
    },
    listText: {
        fontSize: "12px",
        textTransform: "none",
        fontWeight: 400,
        fontFamily: "Arial",
        disableRipple: true,
    },
    listPrimary: {
        fontSize: "14px",
        fontWeight: 700,
        fontFamily: "Arial",
        color: "#555555",
    },
    listSecondary: {
        fontSize: "12px",
        fontWeight: 700,
        fontFamily: "Arial",
        color: "#555555",
    },
    cmisBreadcrumb: {
        color: "#00549A ",
    },
    spacing: {
        paddingTop: 0,
        paddingBottom: 0,
    },
});

/*
all params with * are obligatory
title*: title for the filters, placed under main 'Filters' title
useFiltersTitle: boolean defaulting to true allowing to hide the main 'Filters' title that appears above the title param passed in
filterOptions*: array of objects containing the value and name that will be used to filter
filterKeys*: object with 
- optional key 'value' that point to value within filterOptions that will be sent back as 
    the list of selected options. If not defined, list will contain entire objects from selected items of filteredObject
- mandatory key 'name' that point to label within filterOptions
onUpdateFilter*: callback receiving the list of selected objects
useAll: boolean defining if the all option should show
*/
const FilterProperty = ({ title, filterOptions, filterKeys, onUpdateFilter, useAll, useFiltersTitle = true, inputFilter }) => {
    const classes = useStyles();
    const intl = useIntl();
    const selectedFilters = inputFilter || {
        items: [],
        all: true,
    };

    const getFilterOptionValue = (option) => {
        return option;
    };

    const onAllClick = () => {
        const isAllChecked = !selectedFilters.all;
        onUpdateFilter({
            items: isAllChecked ? filterOptions.map(getFilterOptionValue) : [],
            all: isAllChecked,
        });
    };
    const onFilterClick = (value) => {
        if (selectedFilters.items.includes(value)) {
            onUpdateFilter({
                items: selectedFilters.items.filter((val) => val !== value),
                all: false,
            });
        } else {
            const items = [...selectedFilters.items, value];

            onUpdateFilter({
                all: filterOptions.length === items.length,
                items: items,
            });
        }
    };

    if (!filterOptions || filterOptions.length === 0) {
        return null;
    }

    return (
        <List component="div" className={{ root: classes.root }}>
            <ListItem>
                <ListItemText secondary={title} classes={{ primary: classes.listPrimary, secondary: classes.listSecondary }} />
            </ListItem>
            {useAll && (
                <ListItem className={classes.spacing}>
                    <StyledCheckbox handlecheck={onAllClick} checked={selectedFilters.all} value={"all"} />
                    <ListItemText primary={intl.formatMessage(messages.allFilterOption)} classes={{ primary: classes.listText }} />
                </ListItem>
            )}
            {filterOptions.map((option, index) => {
                return (
                    <ListItem key={`${option}:${index}`} className={classes.spacing}>
                        <StyledCheckbox
                            value={getFilterOptionValue(option)}
                            checked={selectedFilters.items.includes(getFilterOptionValue(option)) || (useAll && selectedFilters.all)}
                            handlecheck={() => onFilterClick(getFilterOptionValue(option))}
                        />
                        <ListItemText primary={option} classes={{ primary: classes.listText }} />
                    </ListItem>
                );
            })}
        </List>
    );
};

export default FilterProperty;
